import { Boot } from "@wangeditor/editor";
import attachmentModule from "@wangeditor/plugin-upload-attachment";
import { createApp } from "vue";
import ElementPlus from "element-plus";
import * as ElementIcons from "@element-plus/icons-vue";
import TableV2Compat from "@/components/table-v2/index.vue";
import globalComponents from "@/components";
import func from "@/utils/function";
import { downloadFile } from "@/api/download";
import { downloadFileV2 } from "@/api/downloadFile";
import page from "@/components/page/index.vue";
import Recharge from "@/components/Recharge/index.vue";
import FilterColumn from "@/components/FilterColumn.vue";
import layered from "@/components/login/layered.vue";
import LayeredSsoAgent from "@/components/login/layered_sso_agent.vue";
import LayeredSsoClient from "@/components/login/layered_sso_client.vue";
import ResetPwd from "@/components/ResetPwd/index.vue";
import clientCreate from "@/components/client/create.vue";
import clientEdit from "@/components/client/edit.vue";
import ErrorDialog from "@/components/ErrorDialog.vue";
import Remarks from "@/components/Remarks.vue";
import router from "./router";
import store from "./store";
import i18n from "./locale";
import directive from "./directive";
import "./mock";
import App from "./App.vue";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/dark/css-vars.css";
import "@/assets/style/global.less";
import "@/api/interceptor";
import { isHandledHttpError } from "@/api/http-error";

window.addEventListener(
  "error",
  (event) => {
    if (event.message && event.message.includes("ResizeObserver loop")) {
      event.stopImmediatePropagation();
    }
  },
  true
);

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  const message = (reason && reason.message) || "";
  if (
    isHandledHttpError(reason) ||
    message === "Network Error" ||
    message.includes("timeout") ||
    /Request failed with status code 50[234]/.test(message)
  ) {
    event.preventDefault();
  }
});

Boot.registerModule(attachmentModule);

const app = createApp(App);

app.config.globalProperties.$func = func;
app.config.globalProperties.$downloadFile = downloadFile;
app.config.globalProperties.$downloadFileV2 = downloadFileV2;
app.config.globalProperties.$store = store;
app.use(ElementPlus);
app.component("ElTableV2", TableV2Compat);
app.component("VDataTable", TableV2Compat);
Object.entries(ElementIcons).forEach(([name, component]) => {
  app.component(name, component);
});

app.use(store);
app.use(router);
app.use(i18n);
app.use(globalComponents);
app.use(directive);

app.component("VPage", page);
app.component("VFilterColumn", FilterColumn);
app.component("VLayered", layered);
app.component("VRecharge", Recharge);
app.component("VLayeredSsoAgent", LayeredSsoAgent);
app.component("VLayeredSsoClient", LayeredSsoClient);
app.component("VResetPwd", ResetPwd);
app.component("VClientCreate", clientCreate);
app.component("VClientEdit", clientEdit);
app.component("VErrorDialog", ErrorDialog);
app.component("VRemarks", Remarks);

app.mount("#app");
